module.exports = __webpack_public_path__ + "img/coupon.eccea99f.png";